<template>
    <h1 class="text-center mt-5">{{ $t('common.maintenance_message') }}</h1>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "MaintenancePage",
        computed:{
            ...mapGetters([
                'maintenanceMode'
            ])
        },
        mounted() {
            if(this.maintenanceMode === false){
              this.$router.push('/profile')
            }
        }
    }
</script>

<style scoped>

</style>
